import { render, staticRenderFns } from "./CorporateAuthorCreate.vue?vue&type=template&id=6baabdf8&scoped=true&"
import script from "./CorporateAuthorCreate.vue?vue&type=script&lang=js&"
export * from "./CorporateAuthorCreate.vue?vue&type=script&lang=js&"
import style0 from "./CorporateAuthorCreate.vue?vue&type=style&index=0&id=6baabdf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baabdf8",
  null
  
)

export default component.exports